<h4>
  {{
    'i18n.payments.addBankAccountModal.autopayEffectiveDate.title' | translate
  }}
</h4>
<div>
  {{
    'i18n.payments.addBankAccountModal.autopayEffectiveDate.body' | translate
  }}
</div>
<ion-datetime
  data-cy="autopay-effective-date-calendar"
  *ngIf="minStartDate !== undefined"
  id="autopay-calendar"
  [presentation]="'date'"
  [value]="selectedStartDateString"
  [min]="minStartDateString"
  [max]="maxStartDateString"
  [isDateEnabled]="isWeekday"
  (ionChange)="valueChanged($event)"
></ion-datetime>
